import { IsOptional, IsString, ValidateNested } from "class-validator";
import { PageResponseVm } from "api/core/page-response.vm";
import { Type } from "class-transformer";
import { DeviceVm } from './device.vm';

export class GetDevicesVm extends PageResponseVm<DeviceVm, string> {
  @IsString()
  @IsOptional()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => DeviceVm)
  objects: DeviceVm[];
}
